import { render, staticRenderFns } from "./GrupoEconomico.vue?vue&type=template&id=07b974de&scoped=true&"
import script from "./GrupoEconomico.vue?vue&type=script&lang=js&"
export * from "./GrupoEconomico.vue?vue&type=script&lang=js&"
import style0 from "./GrupoEconomico.vue?vue&type=style&index=0&id=07b974de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b974de",
  null
  
)

export default component.exports